import { render, staticRenderFns } from "./Zoom.vue?vue&type=template&id=60b9187b&scoped=true"
import script from "./Zoom.vue?vue&type=script&lang=js"
export * from "./Zoom.vue?vue&type=script&lang=js"
import style0 from "./Zoom.vue?vue&type=style&index=0&id=60b9187b&prod&scoped=true&lang=css"
import style1 from "./Zoom.vue?vue&type=style&index=1&id=60b9187b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b9187b",
  null
  
)

export default component.exports